import React, { useEffect, useState } from 'react'
import "./CuponsContainer.css"
import { Col, Container, Row } from 'react-bootstrap'
import CuponCard from '../CuponCard/CuponCard'
import axios from 'axios'
function CuponsContainer() {
  const [cupons, setCupons] = useState([])
  useEffect(() => {
    const getAllApis = async () => {
      await axios
        .get(`https://nanosoft.technology/smile/api/coupons`)
        .then(async (res) => {
          setCupons(res.data);


        })
        .catch((error) => {

          console.log(error.response.data);


        });
    }
    getAllApis()

  }, [])
  const today = new Date(); // Get today's date
  const filteredArray = cupons.filter(item => item.numberOfUsage === 0);
  const filteredUsedArray = cupons.filter(item => item.numberOfUsage === 1);
  const filteredExpiredArray = cupons.filter(item => new Date(item.end) < today);


  

  return (
    <section className='Cupons_container'>
      <h3>My Coupons
      </h3>
      <div className='Cupons_box'>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item">
            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Unused Coupons</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Used Coupons</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Expired Coupons</a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div className='mt-5 '>

              <Container fluid>
                
                <Row>
                  {filteredArray&&filteredArray.map((item,index)=>{
                    return(
                      <Col md={6}key={index}>
                      <CuponCard 
                      item={item}
                      />
                    </Col>
                    )
                  })}
               
             
                </Row>
              </Container>

            </div>



          </div>
          <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div className='mt-5 '>

              <Container fluid>
                <Row>
                  {filteredUsedArray&&filteredUsedArray.map((item,index)=>{
                    return(
                      <Col md={6}key={index}>
                      <CuponCard 
                      item={item}
                      />
                    </Col>
                    )
                  })}
          
                </Row>
              </Container>

            </div>
          </div>
          <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <div className='mt-5 '>

              <Container fluid>
                <Row>
                
                {filteredExpiredArray&&filteredExpiredArray.map((item,index)=>{
                    return(
                      <Col md={6}key={index}>
                      <CuponCard 
                      item={item}
                      />
                    </Col>
                    )
                  })}
                </Row>
              </Container>

            </div>
          </div>
        </div>
      </div>
    </section >)
}

export default CuponsContainer